// filepath: apps/web/src/features/directory/admin/DirectoryAdminRoute.tsx
//
// FR-UI-DIR-1 AC-9 — route shell for /directory/admin.

import { DirectoryAdminPage } from "./DirectoryAdminPage";

export function DirectoryAdminRoute(): React.ReactElement {
  return <DirectoryAdminPage />;
}
